import React, { SVGProps } from 'react';
type SVGRProps = {
  titleId?: string;
};
const SvgIcoHistory = ({ titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 32 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    <title id={titleId}>History</title>
    <path
      d="M4.27 16.99C4.27 10.513 9.523 5.262 16 5.262c6.477 0 11.728 5.251 11.728 11.728 0 6.477-5.251 11.728-11.728 11.728-2.056 0-3.989-.529-5.669-1.458"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
    />
    <path
      d="m6.9 15.715-2.48 2.48-2.48-2.48"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="m19.13 20.12-2.796-2.795a1.143 1.143 0 0 1-.335-.808v-5.788"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
    />
  </svg>
);
export default SvgIcoHistory;
